import { VotesModel } from './VotesModel';
import { Firebase } from './Firebase';
import { UserPicturesModel } from './UserPicturesModel';
import { CurrentUserModel } from './CurrentUserModel';
import { OnboardingModel } from 'models/OnboardingModel';

export class RootStore {
  firebase: Firebase;
  currentUser: CurrentUserModel;
  votes: VotesModel;
  userPictures: UserPicturesModel;
  onboarding: OnboardingModel;

  constructor() {
    // TODO: consider moving Firebase somewhere else
    this.firebase = new Firebase();
    this.currentUser = new CurrentUserModel(this);
    this.votes = new VotesModel(this);
    this.userPictures = new UserPicturesModel(this);
    this.onboarding = new OnboardingModel(this);
  }
}
